import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  IMPORTED_DATA_PERMISSIONS,
  IMPORTED_DATA_ROUTE_NAME,
  TRANSLATION_GROUPS_OF_IMPORTED_DATA,
} from '@modules/imported-data/constants';
import { getTranslationKeys } from '@modules/imported-data/translations';
import {
  ADMIN_SETTINGS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

export class ImportedDataModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: IMPORTED_DATA_ROUTE_NAME,
      path: 'imported-data',
      permission: IMPORTED_DATA_PERMISSIONS.SHOW,
      component: () => import('@modules/imported-data/pages/ImportedDataPage/ImportedDataPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_SETTINGS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'SYSTEM_SETTINGS_IMPORTED_DATA'),
      to: {
        name: IMPORTED_DATA_ROUTE_NAME,
      },
      permission: IMPORTED_DATA_PERMISSIONS.SHOW,
      id: IMPORTED_DATA_ROUTE_NAME,
      order: 40,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUPS_OF_IMPORTED_DATA, getTranslationKeys);
  }
}
